import { createRoot } from "react-dom/client";
import "./index.css";
import ChassisSection from "./App.jsx";

function initChassisSection() {
  const container = document.getElementById("chassis-root");
  if (container) {
    const root = createRoot(container);
    root.render(<ChassisSection />);
  } else {
    console.warn("Chassis section container #chassis-root not found");
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initChassisSection);
} else {
  initChassisSection();
}
